import React, { Fragment } from 'react';
import debounce from 'lodash-es/debounce';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { push } from 'react-router-redux/actions';
import {
    setAdminUsersFilterByTypeAsync,
    setAdminUsersFilterBySearchAsync,
    getAdminUsersAfterFilterChangeAsync,
    refetchAdminUsersAsync,
    changePageToUserEditForm,
    setAdminUsersPage,
} from './action';
import { Headline, ErrorBox } from '../../components/text';
import { LoadingIndicator } from '../../components/loaders';
import { Button, Pagination } from '../../components/actions';
import { Checkbox } from '../../components/fields';
import { Page, Separator, Box, CenterContainer } from '../../components/containers';
import {
    getAdminUsersFilterByType,
    getAdminUsersFilterBySearch,
    getAdminUsersAreLoading,
    getAdminUsersLoadingError,
    getAdminUsersList,
    getAdminUsersPage,
    getAdminUsersTotal,
} from '../../selectors';
import { USER_TYPE, USERS_PER_PAGE } from '../../constants';
import { PAGE_ADMIN } from '../../App';
import s from './index.css';

const mapStateToProps = state => ({
    filterByType: getAdminUsersFilterByType(state),
    filterBySearch: getAdminUsersFilterBySearch(state),
    isLoading: getAdminUsersAreLoading(state),
    loadingError: getAdminUsersLoadingError(state),
    users: getAdminUsersList(state),
    usersTotal: getAdminUsersTotal(state),
    page: getAdminUsersPage(state),
});

class AdminUsersPage extends React.Component {
    constructor(props) {
        super(props);

        this.handleDebouncedFilterBySearchChange = debounce(this.handleDebouncedFilterBySearchChange, 300);
    }

    componentDidMount() {
        const page = parseInt(
            this.props.match && this.props.match.params && this.props.match.params.page
                ? this.props.match.params.page
                : '1',
            10
        );

        this.props.dispatch(setAdminUsersPage(!isNaN(page) ? page : 1));
    }

    render() {
        const { filterByType, filterBySearch, isLoading, loadingError, users, usersTotal, page } = this.props;

        return (
            <Page>
                <div className={s.wrapper}>
                    <div className={s.header}>
                        <Headline size="small">Users list</Headline>

                        <LoadingIndicator label="Refreshing users" show={isLoading} />
                    </div>

                    <Separator type="narrow" />

                    {loadingError && (
                        <ErrorBox onClick={this.handleRefetch} label="Could not load users, click here to try again" />
                    )}

                    <Box className={s.filters} addShadow={true}>
                        <div>
                            <p>Show:</p>

                            <Checkbox
                                onChange={this.handleFilterByTypeChange(null)}
                                checked={filterByType === null}
                                label="All"
                            />

                            <Checkbox
                                onChange={this.handleFilterByTypeChange(USER_TYPE.Admin)}
                                checked={filterByType === USER_TYPE.Admin}
                                label="Admin"
                            />

                            <Checkbox
                                onChange={this.handleFilterByTypeChange(USER_TYPE.Customer)}
                                checked={filterByType === USER_TYPE.Customer}
                                label="Portal"
                            />
                        </div>

                        <div>
                            <label>
                                <strong>Search:</strong>
                                <input
                                    onChange={this.handleFilterBySearchChange}
                                    type="text"
                                    placeholder="User name or email"
                                    value={filterBySearch}
                                />
                            </label>
                        </div>
                    </Box>

                    {(users && users.length > 0 && (
                        <Fragment>
                            <div className={s.users}>
                                {users.map(user => (
                                    <Fragment key={user.id}>
                                        <div className={s.id}>
                                            <span>{user.typeId === USER_TYPE.Admin ? 'Admin' : 'Portal'} #</span>
                                            <strong>{user.id}</strong>
                                        </div>
                                        <div className={s.name}>
                                            <p>{user.name}</p>
                                        </div>
                                        <div className={s.email}>
                                            <p>{user.email}</p>
                                        </div>
                                        <div className={classNames(s.status, { [s.active]: user.status || false })}>
                                            <p>{user.status ? 'Active' : 'Disabled'}</p>
                                        </div>
                                        <div className={s.link}>
                                            <Button onClick={this.handleOpeningUserEditForm(user.id)} label="Edit" />
                                        </div>
                                    </Fragment>
                                ))}
                            </div>

                            <Separator />

                            <Pagination
                                onPageChange={this.handlePageChange}
                                countPerPage={USERS_PER_PAGE}
                                currentPage={page}
                                countTotal={usersTotal}
                                displayTotals={true}
                            />
                        </Fragment>
                    )) ||
                        (isLoading && (
                            <CenterContainer isStatic={true}>
                                <LoadingIndicator />
                            </CenterContainer>
                        )) ||
                        (!loadingError && (
                            <div className={s.noResults}>
                                <p>No users matching search criteria.</p>
                            </div>
                        ))}
                </div>
            </Page>
        );
    }

    handleFilterByTypeChange = type => e => {
        this.props.dispatch(setAdminUsersFilterByTypeAsync(type));
    };

    handleFilterBySearchChange = e => {
        this.props.dispatch(setAdminUsersFilterBySearchAsync(e.target.value));
        this.handleDebouncedFilterBySearchChange();
    };

    handleDebouncedFilterBySearchChange = () => {
        this.props.dispatch(getAdminUsersAfterFilterChangeAsync());
    };

    handlePageChange = page => {
        this.props.dispatch(setAdminUsersPage(page));
    };

    handleRefetch = () => {
        this.props.dispatch(refetchAdminUsersAsync());
    };

    handleOpeningUserEditForm = userId => e => {
        this.props.dispatch(changePageToUserEditForm(userId));
    };
}

export default connect(mapStateToProps)(AdminUsersPage);



// WEBPACK FOOTER //
// ./app/web/src/container/AdminUsersPage/index.jsx